import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { callSnackBar } from "../../store/actions/snackbarAction"
import { getVisitByIdApi } from "../../apis/visits.api"
import { callApiAction } from "../../store/actions/commonAction"
import VisitDetailsUi from "./VisitDetailsUi"
import { SNACK_BAR_VARIETNS } from "../../utils/constants"

const VisitDetailsController = ({ id }) => {
    const dispatch = useDispatch()

    const [list, setList] = useState({})
    const [loading, setLoading] = useState(false)

    const fetchList = async () => {
        setLoading(true)
        dispatch(
            callApiAction(
                async () => await getVisitByIdApi({ id }),
                async (response) => {
                    setLoading(false)
                    setList(response)

                },
                (err) => {
                    setLoading(false)
                    setList({})
                    dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.error))
                },
            ),
        )

    }
    useEffect(() => {
        fetchList()
    }, [id])
    return <>

        <VisitDetailsUi

            list={list}
            loading={loading}
        />

    </>
}
export default VisitDetailsController